var path = 'src/app/patients/salt-wasting/clinical-features.html';
var html = "<h1 class=page-header>Clinical Features</h1> <div salt-wasting-clinical-features-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/salt-wasting/clinical-features.html
 ** module id = 596
 ** module chunks = 0
 **/